<template>
    <div class="card qr-code-card" @click="$emit('click')">
        <div class="icon-container">
            <Icon name="qr-code" size="36"></Icon>
        </div>
        <div class="text-container">
            <p class="headline copy-m bold">{{ $t('venue_settings.qr_code_card.headline', { type }) }}</p>
            <p class="subline copy-m">{{ $t('venue_settings.qr_code_card.description') }}</p>
        </div>
    </div>
</template>

<script>
import Icon from '@/components/Icon'
export default {
    name: 'QRCodeCard',
    components: {
        Icon,
    },
    props: {
        type: {
            type: String,
        },
    },
}
</script>

<style scoped lang="sass">
.qr-code-card
    padding: $s
    background: $neutral-black !important
    display: flex
    align-items: center
    cursor: pointer
    +transition(100ms)

    &:hover
        background: $neutral-4 !important

    .icon-container
        width: 64px
        height: 64px
        border-radius: $xs
        background: white
        display: grid
        place-items: center
        margin-right: $m

    .text-container
        .headline
            color: white

        .subline
            color: $neutral-2
</style>
